import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import DialogWrap from '@/components/dialog-wrap'

let dialog // RootDialog instance

Vue.prototype.$dialog = function(options) {
  if (dialog) {
    dialog.options = {
      ...options
    }
  } else {
    dialog = new Vue({
      name: 'RootDialog',
      router,
      store,
      data() {
        return {
          options: { ...options },
          visible: true,
        }
      },
      render(h) {
        return h(DialogWrap, {
          props: {
            ...this.options,
            visible: this.visible,
          },
          on: {
            'update:visible': (val) => {
              this.visible = val
            }
          },
        })
      }
    })

    dialog.$mount()
    document.body.appendChild(dialog.$el)
  }
  // dialog.$children[0].visible = true
  dialog.visible = true
  // dialog.$children[0].visibleInner = true

  // 暴露close方法
  return {
    close: () => dialog.$children[0].close()
  }
}
